import { Typography } from '@mui/material';
import { IconComponent } from '@shared/components/IconComponent';

export const TradeErrorToast = ({ message }: { message: string }) => (
  <Typography variant="subtitle1" style={{ fontWeight: 600, textAlign: 'center', marginBottom: 5 }}>
    <IconComponent name="ri-close-circle-fill" /> {message}
  </Typography>
);
